export default __webpack_public_path__ + "static/media/Nobility_Logo.451ee425.png";